import { mapState } from 'vuex';
import {
  AddressingType,
  BuildingDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'BuildingItem',
  props: {
    building: {
      type: BuildingDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['building-selected'],
})
export default class BuildingItem extends Vue {
  building!: BuildingDTO;
  currentEntrancePlant!: EntrancePlantDetailDTO;

  get risersFloorApartmentCount() {
    let risersCount = '';
    let floorsCount = '';
    let apartmentsCount = '';

    if (
      this.currentEntrancePlant.addressingType ===
      AddressingType.BuildingRiserFloorApartment
    ) {
      risersCount = `${this.building.risers?.length} ${this.$t(
        'AppResourceEP.Risers'
      )}`;
      floorsCount = `${this.building.floors?.length} ${this.$t(
        'AppResourceEP.Floors'
      )}`;
    }

    apartmentsCount = `${this.building.apartments?.length} ${this.$t(
      'AppResourceEP.Apartments'
    )}`;

    return `${risersCount} ${floorsCount} ${apartmentsCount}`;
  }
}
